import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import Button from '../../components/Button';
import Input from '../../components/Input';
import './styles.css';

const Cadastro: React.FC = () => {
  const { register } = useAuth();
  const { darkMode } = useTheme();
  const navigate = useNavigate();
  
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (success) {
      // Redirecionar automaticamente após o cadastro bem-sucedido
      navigate('/');
    }
  }, [success, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!name || !email || !phone || !password || !confirmPassword) {
      setError('Por favor, preencha todos os campos');
      return;
    }
    
    if (password.length < 6) {
    setError('A senha deve ter pelo menos 6 caracteres.');
    return;
  }

  if (password !== confirmPassword) {
      setError('As senhas não coincidem');
      return;
    }
    
    
    
    setLoading(true);
    setError('');
    
    try {
      console.log('Attempting registration with email:', email);
      await register(name, email, phone, password);
      console.log('Registration successful for email:', email);
      setSuccess(true);
    } catch (err: any) {
      console.error('Registration error:', err);
      if (err?.message) {
        setError(err.message);
      } else {
        setError('Erro ao criar conta. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  const formatPhone = (value: string) => {
    // Remove tudo que não é número
    const numbers = value.replace(/\D/g, '');
    
    // Aplica a máscara (XX) XXXXX-XXXX
    if (numbers.length <= 11) {
      return numbers
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2')
        .replace(/(-\d{4})\d+?$/, '$1');
    }
    
    return value;
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPhone(formatPhone(e.target.value));
  };

  return (
    <div className={`body-wrapper auth-wrapper d-flex align-items-stretch ${darkMode ? 'dark-mode' : ''}`}>
      <div className="d-flex flex-grow flex-column-reverse flex-sm-row w-100">
        <div className="auth-bg py-5 py-sm-0 col-sm-6">
          <p className="auth-credits py-5">
            <span className="footer-message">
              {/* heart removed */} <br />
            </span>
            <small className="footer-copyright">
              Copyright © 2025 - Trading<br />Todos os direitos reservados.
            </small>
          </p>
        </div>
        
        <div className="auth-panel-wrapper col">
          <div className="auth-panel py-5">
            <img 
              src="/logo-trading.png" 
              className="auth-logo mx-auto" 
              alt="Trading Logo"
            />
            
            <div className="row auth-tab pt-4 pb-3">
              <div className="col">
                <Link to="/login" className="auth-link">
                  Acessar sua conta
                </Link>
              </div>
              <div className="col">
                <span className="auth-link active">
                  Crie sua conta
                </span>
              </div>
            </div>
            
            <form onSubmit={handleSubmit}>
              {error && <div className="alert alert-danger">{error}</div>}
              {success && (
                <div className="alert alert-success" role="alert">
                  Cadastro realizado com sucesso! Redirecionando...
                </div>
              )}
              
              <div className="form-group">
                <Input
                  label="Nome completo"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Seu nome completo"
                  autocomplete="name"
                  required
                />
              </div>
              
              <div className="form-group py-3">
                <Input
                  label="E-mail"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Seu melhor e-mail"
                  autocomplete="username"
                  required
                />
              </div>
              
              <div className="form-group pb-3">
                <Input
                  label="Telefone"
                  type="tel"
                  value={phone}
                  onChange={handlePhoneChange}
                  placeholder="(00) 00000-0000"
                  autocomplete="tel"
                  required
                />
              </div>
              
              <div className="form-group pb-3">
                <Input
                  label="Senha"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Crie uma senha segura"
                  autocomplete="new-password"
                  required
                />
              </div>
              
              <div className="form-group pb-3">
                <Input
                  label="Confirmar senha"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirme sua senha"
                  autocomplete="new-password"
                  required
                />
              </div>
              
<div className="form-group pb-4 terms-agreement">
  <small style={{ color: 'white', fontSize: '13px' }}>
    Ao criar uma conta, você concorda com os{' '}
    <Link to="/termos-de-uso" className="terms-link">
      termos de uso
    </Link>.
  </small>
</div>

              <Button 
                type="submit" 
                variant="auth" 
                fullWidth 
                disabled={loading}
              >
                {loading ? 'Criando conta...' : 'Criar conta'}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cadastro;